// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"40":"72f8c5d3","654":"db2c8ad5","700":"17bd4900","718":"28ef5860","842":"cb565b79","953":"d5897c34","974":"98c9eb3c"}[chunkId] + ".js";
};